// Module
var code = "<ib-pre-selection-menu-options\n    data-ng-if=\"preSelectionMainCtrl.currentStep === 'menu_options'\"></ib-pre-selection-menu-options>\n<ib-pre-selection-summary\n    data-ng-if=\"preSelectionMainCtrl.currentStep === 'summary_selection'\"></ib-pre-selection-summary>\n";
// Exports
module.exports = code;